// extracted by mini-css-extract-plugin
export default {"content":"LearnPage_content__aWBhp","bg":"LearnPage_bg__yZn-W","studyDashboard":"LearnPage_studyDashboard__BqBFa","course-create-body":"LearnPage_course-create-body__luutS"};